document.addEventListener("DOMContentLoaded", (event) => {
  /*document.querySelectorAll("*").forEach((element) => {
    element.addEventListener("focus", function(event) {
        console.log("Focus Element");
        console.log(event.target);
    });
  });*/

  /*let linkedSlideShows = document.querySelectorAll(".linked-mini-blocks");
  if (linkedSlideShows) {
    linkedSlideShows.forEach((slideshow) => {
      let section = slideshow.closest(".shopify-section.section.slideshow-banner-section");
      let slideDots = slideshow.querySelectorAll(".slider-counter.slider-counter--dots .slider-counter__link.slider-counter__link--dots");
      let index = 0;
      let miniBlockSection = section.nextElementSibling;
      let miniBlocks = miniBlockSection.querySelectorAll(".mini-block");
      if (miniBlockSection && slideDots && miniBlocks) {
        slideDots.forEach((dot, index) => {
          if (dot.classList.contains("slider-counter__link--active")) {
            miniBlocks[index].classList.add("mini-block--active");
          } else {
            if (miniBlocks[index]) {
              miniBlocks[index].classList.remove("mini-block--active");
            }
          }
        });
      }

      slideshow.addEventListener("slideChanged", function(event) {
        let newIndex = event.detail.currentPage - 1;
        miniBlocks.forEach((block, index) => {
          if (index == newIndex) {
            miniBlocks[index].classList.add("mini-block--active");
          } else {
            miniBlocks[index].classList.remove("mini-block--active");
          }
        });

      }); 
    });
  }*/

});